import React from 'react';
import { Link } from 'react-router-dom';
import useDocumentTitle from '../hooks/useDocumentTitle';
import useMain from '../hooks/useMain';
import Image from './common/image';

const NotFound = () => {
	const { theme } = useMain();
	useDocumentTitle(['Not Found']);
	return (
		<main className='container'>
			<div className='row my-5'>
				<div className='col-md-8 offset-md-2 col text-center'>
					<Image
						className='w-100 pt-4'
						fileName={`utility_${theme}/404.webp`}
					/>

					<p className='fs-4'>
						You weren't supposed to see this... it was meant to be a surprise!
					</p>
					<Link
						className='nav-link'
						to='/'>
						<button
							type='button'
							className={`btn btn-outline-set2-${theme}`}
							id='loginHeader'>
							Take me back home!
						</button>
					</Link>
				</div>
			</div>
		</main>
	);
};

export default NotFound;
